"use client";

import ArrowRight from "@/assets/Icons/arrowRight";
import { useGetBlog } from "@/components/parts/admin/website-management/blog/api";
import CardNews from "@/components/parts/landing/news/cardNews";
import Link from "next/link";
import React from "react";

const NewsSection = () => {
  const { data } = useGetBlog("limit=3");
  const detail = data?.data.items;

  return (
    <div className="flex flex-col gap-3 container mx-auto">
      <div className="flex gap-3 md:flex-row flex-col justify-between items-center">
        <div className="">
          <div className="text-xl md:text-2xl font-semibold">Berita</div>
          <div className="text-[#70707B] text-sm md:text-base">
            Berikut adalah informasi terkini seputar program, kegiatan, dan
            inovasi di lingkungan Dinas Pertanian.
          </div>
        </div>
        <div className="w-full md:w-fit">
          <Link
            href="/information/news"
            className="bg-primary border text-sm md:text-base p-2.5 px-4 w-full md:w-fit hover:bg-primary-600 rounded-full text-center flex justify-center items-center gap-2 text-white"
          >
            Lihat Selengkapnya
            <ArrowRight />
          </Link>
        </div>
      </div>
      {/*  */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {detail?.map((item, index) => (
          <CardNews
            key={index}
            date={item.updatedAt}
            category={item.articleCategory}
            title={item.title}
            description={item.description}
            image={item.image}
            href={`/information/news/${item.id}`}
          />
        ))}
      </div>
    </div>
  );
};

export default NewsSection;
